<template>
  <div>
    <v-tabs class="w-100" :height="60" bg-color="primary" slider-color="accent" v-model="activeTab">
      <v-tab :key="0">Sales</v-tab>
      <v-tab :key="1">Materials</v-tab>
      <v-tab :key="2">UK Delivered</v-tab>
      <v-tab :key="3">EU Delivered</v-tab>
      <v-tab :key="4">US Delivered</v-tab>
    </v-tabs>
    <component :is="tabComponents[activeTab]"></component>
  </div>
</template>
<script>
import SalesPerformance from '@/components/analytics/SalesPerformance'
import MaterialsInformation from '@/components/analytics/MaterialsInformation'
import DeliveredLocation from '@/components/analytics/DeliveredLocation'
import EuDeliveredLocation from '@/components/analytics/EuDeliveredLocation'
import UsDeliveredLocation from '@/components/analytics/UsDeliveredLocation'

export default {
  name: 'analytics',
  components: { SalesPerformance, MaterialsInformation, DeliveredLocation, EuDeliveredLocation, UsDeliveredLocation },
  data() {
    return {
      activeTab: 0,
      tabComponents: [
        'SalesPerformance',
        'MaterialsInformation',
        'DeliveredLocation',
        'EuDeliveredLocation',
        'UsDeliveredLocation'
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
#analytics {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 100%;
}
</style>
